<ngx-loading-bar [color]="'#ff8913'" [includeBar]="true" [includeSpinner]="true" [height]="'8px'"></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>
<!--<p><strong>{{idleState}}</strong></p>-->
<!--<p *ngIf="lastPing"><small>Last keepalive ping <strong>{{lastPing | amTimeAgo}}</strong></small></p>-->
<!--<button (click)="reset()" *ngIf="timedOut">Restart</button>-->
